import { Text } from "@chakra-ui/react";

import { SmallTileCard } from "@/components/small-tile-card";
import AdministrativeUnits from "@/images/administrative-unit.svg?url";
import atmosphericConditions from "@/images/atmospheric-conditions.svg?url";
import Buildings from "@/images/buildings.svg?url";
import climateImpactAtlas from "@/images/climate-impact-atlas.svg?url";
import Elevation from "@/images/elevation.svg?url";
import Hydrography from "@/images/hydrography.svg?url";
import Hydrology from "@/images/hydrology.svg?url";
import LandCover from "@/images/land-cover.svg?url";
import LandUse from "@/images/land-use.svg?url";
import meteorologicalGeographicalFeatures from "@/images/meteorological-geographical-features.svg?url";
import naturalRiskZones from "@/images/natural-risk-zones.svg?url";
import Soil from "@/images/soil.svg?url";
import TransportNetwork from "@/images/transport-network.svg?url";
import UnknownCategory from "@/images/unknown-category.png";

type DatasetCategoryCardProps = {
  category: string;
  setSelectedCategory: (category: string) => void;
  amountInCategory: number;
};

const getImageSrc = (category: string) => {
  // prettier-ignore
  switch (category) {
    case "Administrative units": return AdministrativeUnits;
    case "Atmospheric conditions": return atmosphericConditions;
    case "Buildings": return Buildings;
    case "Climate Impact Atlas": return climateImpactAtlas;
    case "Elevation": return Elevation;
    case "Hydrography": return Hydrography;
    case "Hydrology": return Hydrology;
    case "Land cover": return LandCover;
    case "Land use": return LandUse;
    case "Meteorological geographical features": return meteorologicalGeographicalFeatures;
    case "Natural risk zones": return naturalRiskZones;
    case "Soil": return Soil;
    case "Transport networks": return TransportNetwork;
    default: return UnknownCategory;
  }
};

export const DatasetCategoryCard = ({
  category,
  setSelectedCategory,
  amountInCategory,
}: DatasetCategoryCardProps) => {
  const imageSrc = getImageSrc(category);

  return (
    <SmallTileCard
      imageSrc={imageSrc}
      imageAlt="category-image"
      textAlign="center"
      onClick={() => setSelectedCategory(category)}
      title={
        <>
          {category}
          <Text as="span" ml={2} opacity={0.6} fontWeight="light">
            ({amountInCategory})
          </Text>
        </>
      }
    />
  );
};
